import { render, staticRenderFns } from "./StockBorraEnMagatzemsList.vue?vue&type=template&id=2e3a4bba&scoped=true"
import script from "./StockBorraEnMagatzemsList.vue?vue&type=script&lang=js"
export * from "./StockBorraEnMagatzemsList.vue?vue&type=script&lang=js"
import style0 from "./StockBorraEnMagatzemsList.vue?vue&type=style&index=0&id=2e3a4bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3a4bba",
  null
  
)

export default component.exports